import React, { useState, useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";

import classes from "./Select.module.css";

let _selectCopiesAttrId = null;

export default function Select({
  packagePrices,
  state,
  setState,
  field,
  options,
  label,
  defaultValue,
  lastInputRef
}) {
  const selectedProductAttributesState = useSelector(
    state => state.productReducer.selectedProductAttributes,
    shallowEqual
  );

  const attributeDetailsState = useSelector(
    state => state.productReducer.itemDetail.attributeDetails,
    shallowEqual
  );

  let selectCopiesAttrId = null;
  if (packagePrices) {
    if (_selectCopiesAttrId) {
      selectCopiesAttrId = _selectCopiesAttrId;
    } else {
      selectCopiesAttrId =
        attributeDetailsState &&
        attributeDetailsState.find(attr =>
          [
            "Select Copies",
            "Select number of copies",
            "Choisissez le nombre de copies"
          ].includes(attr.dropname)
        );
      selectCopiesAttrId = selectCopiesAttrId && selectCopiesAttrId.attributeid;
    }
    if (selectCopiesAttrId) _selectCopiesAttrId = selectCopiesAttrId;
  }

  const itemIdState = useSelector(
    state => state.productReducer.itemDetail.itemid,
    shallowEqual
  );

  const [selectedQuantity, setSelectedQuantity] = useState(
    packagePrices && state && state.text
  );

  useEffect(() => {
    if (defaultValue) {
      console.info("borop22", defaultValue);
      setSelectedQuantity(Number(defaultValue));
      if (foundPackage) {
        const foundPrice = foundPackage.prices.find(
          p => p.quantity.toString() === defaultValue.toString()
        );
        if (foundPrice)
          setState({
            ...state,
            text: foundPrice.quantity,
            value: foundPrice.price
          });
      } else {
        setState({
          ...state,
          ...options.find(
            opt => opt.text.toString() === defaultValue.toString()
          )
        });
      }
    }
  }, []);

  useEffect(() => {
    if (state && state.text) {
      console.info("defaultValue2", defaultValue);
      setSelectedQuantity(state.text);
    }
  }, [state && state.text]);

  const [foundPackage, setFoundPackage] = useState(null);
  useEffect(() => {
    if (
      packagePrices &&
      selectedProductAttributesState &&
      selectedProductAttributesState[itemIdState] &&
      selectedProductAttributesState[itemIdState][selectCopiesAttrId] &&
      selectedProductAttributesState[itemIdState][selectCopiesAttrId].ddtext &&
      selectCopiesAttrId
    ) {
      console.log("packagePrices22", packagePrices);
      const ddtext =
        selectedProductAttributesState[itemIdState] &&
        selectedProductAttributesState[itemIdState][selectCopiesAttrId] &&
        selectedProductAttributesState[itemIdState][selectCopiesAttrId].ddtext;

      const foundPackage = packagePrices.find(p => {
        if (p.label.includes(" ")) {
          const labelNumber = p.label.split(" ")[0];
          if (!ddtext.includes(" ")) {
            return labelNumber === ddtext;
          } else {
            const ddtextFirstWord = ddtext.split(" ")[0];
            return labelNumber === ddtextFirstWord;
          }
        } else {
          return p.label === ddtext;
        }
      });
      console.info("borop22", foundPackage, selectedQuantity);
      if (foundPackage) {
        setFoundPackage(foundPackage);
        const foundPrice = foundPackage.prices.find(
          p => p.quantity.toString() === selectedQuantity.toString()
        );

        setState({
          ...state,
          text: foundPrice.quantity,
          value: foundPrice.price
        });
      }
    }
  }, [selectedProductAttributesState]);

  console.info("borop2", state, "field:", field);
  const handleOnChange = e => {
    const { value } = e.target;
    console.info("borop2", packagePrices, state, value, options, foundPackage);
    setSelectedQuantity(Number(value));
    if (foundPackage) {
      const foundPrice = foundPackage.prices.find(
        p => p.quantity.toString() === value
      );
      if (foundPrice)
        setState({
          ...state,
          text: foundPrice.quantity,
          value: foundPrice.price
        });
    } else {
      setState({
        ...state,
        ...options.find(opt => opt.text.toString() === value)
      });
    }
  };

  return (
    <div className={classes.wrapper}>
      <label for={field.replace(/ /g, "-")}>{label}</label>
      <select
        id={field.replace(/ /g, "-")}
        value={state && state.text}
        name={field}
        onChange={handleOnChange}
        ref={lastInputRef}
      >
        {options.map(opt => (
          <option key={opt.text} value={opt.text}>
            {opt.text} {opt && opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
